module.exports = __webpack_public_path__ + "img/ch16_12_营救破门.933e39b0.jpg";